const FLAG_URL = "https://customer-assets.emergentagent.com/job_project-kickoff-24/artifacts/si6ptofl_Burundi%20Flag%20EMBOSSED.jpg";

export default function WorkInProgressPage() {
  return (
    <div data-testid="wip-page" className="relative min-h-screen w-full bg-black text-white flex items-center justify-center overflow-hidden px-6">
      <div className="absolute top-0 left-0 w-full h-1 flex">
        <div className="flex-1 bg-red-600" />
        <div className="flex-1 bg-green-600" />
      </div>
      <div className="flex flex-col items-start max-w-xl">
        <img data-testid="wip-logo" src={FLAG_URL} alt="GeoCore Global" className="w-20 h-20 rounded-full object-cover border-2 border-green-600 mb-8" />
        <h1 data-testid="wip-brand" className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight">
          GeoCore <span className="text-red-600">Global</span>
        </h1>
        <p data-testid="wip-message" className="mt-6 text-base md:text-lg text-gray-300">
          Our website is currently a work in progress. We're building something new — please check back soon.
        </p>
        <div className="mt-10 flex items-center gap-3 text-sm text-green-500 uppercase tracking-widest">
          <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
          Coming soon
        </div>
      </div>
      <div className="absolute bottom-0 left-0 w-full h-1 flex">
        <div className="flex-1 bg-green-600" />
        <div className="flex-1 bg-red-600" />
      </div>
    </div>
  );
}
